// packages/shared-hooks/src/leads/useAssignLead.ts
//
// `POST /leads/:id/assign` — capability-gated manual assignment. The backend
// remains authoritative for ownership, target-duty, and terminal-state rules.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LeadListItemSchema, type AssignLeadInput, type LeadListItem } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { engagementsKeys } from '../engagements/keys.js';
import { leadsKeys } from './keys.js';

export function useAssignLead(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LeadListItem, unknown, AssignLeadInput>({
    mutationFn: (input) =>
      client.post<LeadListItem>(`/leads/${id}/assign`, input, {}, LeadListItemSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadsKeys.all });
      void qc.invalidateQueries({ queryKey: engagementsKeys.all });
    },
  });
}
